export const forma = {
    id: 984122,
    name: "Forma",
    network: "forma",
    nativeCurrency: {
        symbol: "TIA",
        name: "TIA",
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ["https://rpc.forma.art"],
            webSocket: ["wss://rpc.forma.art"],
        },
        public: {
            http: ["https://rpc.forma.art"],
            webSocket: ["wss://rpc.forma.art"],
        },
    },
    blockExplorers: {
        default: {
            name: "Forma Explorer",
            url: "https://explorer.forma.art",
        },
    },
    contracts: {
        multicall3: {
            address: "0xC5402e0BAF74c1042D72749cB8cA78c58dD93D6f",
            blockCreated: 1289867,
        },
    },
};
